import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";
import { FiltroEntregaOcurreComponent } from "./filtro";

type Entity = models.EntregaOcurreDTO;
const resource = resources.EntregaOcurre;

interface State {
    filtro: models.EntregaOcurreFiltro;
}

/**Listado de todas las entregas a ocurre */
export class EntregaOcurreList extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = { filtro: {} };
    }

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resources.EntregaOcurre.ConsultarEntregas, filtro));

    onVer = async (x: Entity) => {
        history.go("./" + x.IdRegistro);
    }
    onImprimirAcuses = async (x: Entity) => {
        const data = await resources.EntregaOcurre.ImprimirAcusesInternos(x.IdRegistro);
        await kea.printPdf(data);
    }

    render() {
        const cols = columnas(this);
        const items = this.items(this.state);
        return (
            <div>
                <FiltroEntregaOcurreComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />
                <kea.Grid2 columnas={cols} cookieKey={"EntregaOcurreListCookieKey"} items={items} />
            </div>
        )
    }
}       



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/list/list.tsx